import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiEndpoints } from '../constants/api-endpoints';
import { IUserSelectQaCode } from '../interfaces/user-select-qa';
import { HttpUtilityService } from './http.utility.service';

@Injectable({
  providedIn: 'root',
})
export class UserSelectQaService {
  constructor(private readonly httpUtilityService: HttpUtilityService) {}

  getAllList(): Observable<HttpResponse<IUserSelectQaCode[]>> {
    return this.httpUtilityService.get<IUserSelectQaCode[]>(
      apiEndpoints.userSelectLoadQa
    );
  }
}
